const Food = props => {
    return (
        <svg className={props.className || ""} viewBox="0 -960 960 960" ><path d="M173.46-133.85 131.31-176 539-583.69q-19.15-45.08-6.92-94.81 12.23-49.73 54.31-90.58 46.07-46.07 107.99-58.15 61.93-12.08 102.16 28.15t28.15 102.16q-12.08 61.92-58.15 108-40.85 42.07-90.58 54.3-49.73 12.23-94.81-6.92L519.61-480l304 304-42.15 42.15-304-302-304 302Zm120.31-339.69L178.39-588.92Q129-638.31 127.27-706.38q-1.73-68.08 44.96-119.77l236.46 237.69-114.92 114.92Z"/></svg>
    )
}
export default Food;